import { roles as rolesColors, rolesText as rolesTextColors } from '../utils/listingColors';

export default {
  methods: {
    cardColor(item) {
      return (item.rank) ? rolesColors[`${item.role}_${item.rank}`] : rolesColors[item.role];
    },
    cardTextColor(item) {
      return (item.rank) ? rolesTextColors[`${item.role}_${item.rank}`] : rolesTextColors[item.role];
    },
  },
};
